import React, { createContext, useContext, useState, useCallback } from 'react';

const InvoiceContext = createContext();

export const useInvoice = () => {
  const context = useContext(InvoiceContext);
  if (!context) {
    throw new Error('useInvoice must be used within an InvoiceProvider');
  }
  return context;
};

export const InvoiceProvider = ({ children }) => {
  const [currentInvoice, setCurrentInvoice] = useState(null);
  const [companySettings, setCompanySettings] = useState(null);
  const [formattedAddress, setFormattedAddress] = useState('');

  const updateCurrentInvoice = useCallback((invoiceData) => {
    setCurrentInvoice(invoiceData);
  }, []);

  const updateCompanySettings = useCallback((settings) => {
    setCompanySettings(settings);
  }, []);

  const updateFormattedAddress = useCallback((address) => {
    setFormattedAddress(address);
  }, []);

  const clearCurrentInvoice = useCallback(() => {
    setCurrentInvoice(null);
    setCompanySettings(null);
    setFormattedAddress('');
  }, []);

  const value = {
    currentInvoice,
    companySettings,
    formattedAddress,
    updateCurrentInvoice,
    updateCompanySettings,
    updateFormattedAddress,
    clearCurrentInvoice
  };

  return (
    <InvoiceContext.Provider value={value}>
      {children}
    </InvoiceContext.Provider>
  );
};
